import { render } from "./AdmCollectMng.vue?vue&type=template&id=61889bc0&scoped=true"
import script from "./AdmCollectMng.vue?vue&type=script&lang=js"
export * from "./AdmCollectMng.vue?vue&type=script&lang=js"

import "./AdmCollectMng.vue?vue&type=style&index=0&id=61889bc0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61889bc0"]])

export default __exports__